import jwtDecode from "jwt-decode";

const getCompanyIdFromToken = () => {
	const token = localStorage.getItem("access-token");

	if (token) {
		const companyId = jwtDecode(token).company_id;
		return companyId;
	}
};

export default getCompanyIdFromToken;
